import { Injectable } from '@angular/core';
import { CustomerSearchPage } from '@asm/const';
import { AsmActions, AsmConnector } from '@asm/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { normalizeHttpError } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class CustomerEffects {
  customerSearch$: Observable<AsmActions.CustomerAction> = createEffect(() =>
    this.actions$.pipe(
      ofType(AsmActions.CUSTOMER_SEARCH),
      map((action: AsmActions.CustomerSearch) => action.payload),
      switchMap((options) =>
        this.asmConnector.customerSearch(options).pipe(
          map((customerSearchResults: CustomerSearchPage) => {
            return new AsmActions.CustomerSearchSuccess(customerSearchResults);
          }),
          catchError((error) => of(new AsmActions.CustomerSearchFail(normalizeHttpError(error)))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private asmConnector: AsmConnector,
  ) {}
}
